import axios from 'axios';
import NProgress from 'nprogress';
import { Modal } from 'mui';
import { logout } from './index';
import Cookies from 'js-cookie';

// axios.defaults.timeout = 15000; // 请求超时时间
axios.defaults.headers.withCredentials = true;
let switchLanguage = function (lang) {
  switch (lang) {
    case 'zh-CN':
      return 'ZHS';
      break;
    case 'en-US':
      return 'US';
      break;
    case 'th':
      return 'EN_TH';
      break;
    default:
        return 'US';
  }
}
let switchLanguageToQms = function (lang) {
  // QMS语言 ZH_CN=中文，EN_US=英文，JA_JP=日语，EN_TH=泰语，VI_VN=越南语 
  switch (lang) {
    case 'zh-CN':
      return 'ZH_CN';
      break;
    case 'en-US':
      return 'EN_US';
      break;
    case 'th':
      return 'EN_TH';
      break;
    default:
        return 'EN_US';
  }
}
// request拦截器
axios.interceptors.request.use(config => {
  console.log('config', config);
  NProgress.start();
    if (config.url.includes('/gscint/req')) {
        return config;
    }
  if (config.method === 'get') {
    // qms2gsc 语言转换
    if (config.url.startsWith('/qms2gsc') && config.params && config.params.language) {
      config.params.language = switchLanguageToQms(config.params.language);
    }
    config.params = {
      _t: new Date().getTime(),
        ...config.params
    };
  } else {
    // 采购订单查询、绩效考核语言参数特殊处理(排除一些不需要处理的接口)
    if (!['/hw/ispInvoice', '/gscint/payPlan', 'srmbase/basicConfig/queryDictionaryType'].some((item) => config.url.indexOf(item) > -1)) {
        if (config.data && config.data.language) {
            config.data = {
            ...config.data,
            language: config.url.indexOf('composite') > -1 ? config.data.language : (config.url.startsWith('/qms2gsc') ? switchLanguageToQms(config.data.language) :switchLanguage(config.data.language))
            }
        }
    }
  }
  /* 财务模块接口增加_language */
  if (['/gscint/hwVendorAccounter/', '/gscint/bill', '/gscint/hw'].find((item) => config.url.indexOf(item) > -1)) {
    const _language = {
        'zh-CN': 'ZHS',
        'en-US': 'US',
        'th': 'US',
        'vi': 'US',
    }[Cookies.get('iflow_locale') || 'zh-CN'];
    config.data = config.data || {};
    config.params = config.params || {};
    config[config.method === 'get' ? 'params' : 'data']._language = _language;
  }
  return config;
}, error => {
  NProgress.done();
  Promise.reject(error);
});

// respone拦截器
axios.interceptors.response.use(
  response => {
    NProgress.done();
    return response;
  },
  error => {
    NProgress.done();
    const response = Object.assign({}, error.response);
    if (response) {
      // 4A整改：MAS_TGC改成httpOnly，所以下面接口报401不做处理
      if ('/gscint/vendor/getCurrentVendor' === response.config.url && window.location.hash.includes('/login')) { return Promise.reject(response); }

      switch (response.status) {
        case 401:
          Modal.error({
            content: "You haven't logged in yet"
          });
          logout();
          break;
        case 404:
        //   Modal.error({
        //     content: 'No interface information found'
        //   });
          break;
        case 500:
        //   Modal.error({
        //     content: 'System anomaly'
        //   });
          break;
        default:
      }
    }
    return Promise.reject(error);
  },
);

export default axios;
